<template>
  <div class="section-container">
    <div class="main-container clearfix">
      <person :counselor-id="counselorId" :loan-type-arr="loanTypeArr"/>
      <div class="articles-content">
        <h3 class="title">{{article.title}}</h3>
        <p class="articles-top clearfix">
          <span class="release-date">发布日期：{{article.auditDate}}</span>
          <span class="article-type">文章类型：{{article.copyright}}</span>
        </p>
        <div class="articles-txt" v-html="article.content"></div>
      </div>
      <br />
    </div>
  </div>
</template>

<script type="text/javascript">
  import Person from '@/components/consultant/person'
  export default {
    data () {
      return {
        counselorId: null,
        articleId: null,
        article: {},
        copyRightTag: null,
        loanTypeArr: []
      }
    },
    created () {
      this.counselorId = this.$route.params.uid
      this.articleId = this.$route.query.articleId
      this.getLoanTypeArr()
      this._fetchArticleById()
    },
    watch: {
      '$store.state.city' () {
        this.$router.push(`/consultant/counserlor`)
      }
    },
    methods: {
      getLoanTypeArr () {
        let vm = this
        this.$http({
          url: '/getLoanTypeMap.jhtml',
          data: {
            cityNo: this.$store.state.city.code
          },
          done (result) {
            vm.loanTypeArr = [].concat(result)
          }
        })
      },
      _fetchArticleById () {
        let vm = this
        this.$http({
          url: '/getArticleInfo.jhtml',
          data: {
            type: '3',
            articleId: this.articleId
          },
          done (result) {
            vm.article = result || {}
          }
        })
      }
    },
    components: {
      Person
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
.main-container
  padding-top 44px
  .articles-content
    margin 0
    padding 0
    margin-top 50px
    font-size 14px
    color #333
    padding 0 33px
    .title
      margin: 0;
      padding: 0;
      text-align: center;
      font-size: 18px;
      color: #333;
      margin-bottom: 18px;
    .articles-top
      margin 0
      padding 0
      position relative
      margin-bottom 20px
      .release-date
        position absolute
        left 20px
      .article-type
        position absolute
        left 255px
    .articles-txt
      text-indent 2em
      padding 15px 20px
      font-size 14px
      color #333
      letter-spacing 2px
</style>



// WEBPACK FOOTER //
// article.vue?9e9dcf30